<template>
    <div>
        <div
            v-if="isCreatable"
            class="kgr-region kgr-region--lightGray kgr-region--rounded kgr-row kgr-row--bigMargin"
        >
            <div
                v-if="isEmpty"
                class="kgr-row kgr-row--bigMargin"
            >
                <i v-t="'Keine Vertretungsberechtigten vorhanden.'"></i>
            </div>
            <div
                v-else
                class="kgr-row kgr-row--bigMargin"
            >
                <div
                    v-if="member"
                >
                    <member-relation-row
                        v-for="legalRepresentative in legalRepresentatives"
                        :key="legalRepresentative.id"
                        :is-deletable="isDeletable"
                        :member="legalRepresentative"
                        :pending-remove="pendingUpdate"
                        :remove-button-label="$t('Vertretungsberechtigung für %{fullName} entfernen', { fullName: member?.fullName() })"
                        :legal-member="member"
                        :hide-middle-button="true"
                        @remove="$emit(`remove`, legalRepresentative)"
                    />
                </div>
            </div>

            <h2 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                {{ $t('member.legalRepresentatives.create.title', { fullName: member?.fullName() }) }}
            </h2>

            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top">
                <div
                    class="kgr-postfix__fixed"
                    :class="{ 'error-state': error.forField('selectedLegalRepresentative') }"
                >
                    <kgr-club-member-select
                        v-model="selectedLegalRepresentative"
                        :club-id="clubId"
                        @update:members="filterAndSortMembers"
                    />
                </div>

                <div class="kgr-postfix__fixed">
                    <kgr-button
                        :value="$t('add')"
                        :pending="pendingUpdate"
                        :disabled="disabled"
                        @click="add"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClubMemberSelect from '../common/form/select/ClubMemberSelect';
import Error from '../../js/model/Error';
import KgrButton from '../common/form/button/KgrButton';
import MemberRelationRow from './MemberRelationRow';

export default {
    components: {
        MemberRelationRow,
        'kgr-button': KgrButton,
        'kgr-club-member-select': ClubMemberSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        member: {
            type: Object,
            required: false,
            default: null,
        },
        legalRepresentatives: {
            type: Array,
            required: true,
        },
        relations: {
            type: Array,
            required: true,
        },
        pendingUpdate: {
            type: Boolean,
            required: false,
            default: false,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            selectedLegalRepresentative: null,
            error: new Error(),
        };
    },
    computed: {
        isEmpty() {
            return this.legalRepresentatives.length === 0;
        },
        disabled() {
            return this.selectedLegalRepresentative === null;
        },
    },
    methods: {
        filterAndSortMembers(props) {
            const compare = (o1, o2) => {
                const isInRelation1 = this.relations.findIndex((relation) => relation.memberA.id === o1.id || relation.memberB.id === o1.id) !== -1;
                const isInRelation2 = this.relations.findIndex((relation) => relation.memberA.id === o2.id || relation.memberB.id === o2.id) !== -1;

                if (isInRelation1 && !isInRelation2) {
                    return -1;
                }
                if (!isInRelation1 && isInRelation2) {
                    return 1;
                }

                const s1 = o1.firstName + o1.lastName;
                const s2 = o2.firstName + o2.lastName;

                return s1.toLowerCase().localeCompare(s2.toLowerCase());
            };

            props.members = props.members
                .filter((member) => this.memberId !== member.id)
                .filter((member) => this.legalRepresentatives.findIndex((legalRepresentative) => legalRepresentative.id === member.id) === -1)
                .sort(compare);
        },
        add() {
            this.error = new Error();

            if (this.selectedLegalRepresentative === null) {
                this.error.add('selectedLegalRepresentative', 'required!');
                return false;
            }

            this.$emit('add', this.selectedLegalRepresentative);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
